import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService, SortEvent } from 'primeng/api';
import { DaoService } from '../servicos/dao.service';
import { ImageService } from 'angular2-image-upload/lib/image-upload/image.service';
import { FileHolder, UploadMetadata } from 'angular2-image-upload';

@Component({
  selector: 'app-cadastro',
  templateUrl: './cadastro.component.html',
  styleUrls: ['./cadastro.component.css'],
  providers: [ImageService]
})
export class CadastroComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private dao: DaoService, private messageService: MessageService) { }

  @Input()licitacaoKey:any;
  @Input()licitacao:any;
  @Output()volt = new EventEmitter();
  @Input()personalizado: boolean = false;
  acao:any;
  customClass:any;

  formulario: FormGroup;
  nome_arquivo:any;
  nome_completo:any;
  loading:boolean;

  matuarial:any = [
    {label:"Selecione a Categoria",value:null},
    {label:"Relatórios de Gestão Atuarial",value:"gestaoAtuarial"},
    {label:"Relatórios de Gestão Atuarial Progestão",value:"gestaoAtuarialPro"},
    {label:"Resultados Atuariais",value:"resultadosAtuariais"},
    {label:"Audiências Públicas/Prestações de Conta (Câmara)",value:"prestacoesCamara"},
    {label:"Plano de Trabalho Atuarial",value:"planoAtuarial"},

  ];
  mcontabil:any=[
    {label:"Selecione a Categoria",value:null},
    {label:"Informe Contábil",value:"informecontabil"},
    {label:"Orçamentos Contabeis",value:"orcamentoContabil"},
    {label:"Demonstrações Contábeis / Notas Explicativas",value:"notasexplicativas"},
    {label:"Demonstrações Contábeis / Mensais",value:"notasMensais"},
  ];
  mfinanceiro:any = [
    {label:"Selecione a Categoria",value:null},
    {label:"APR'S",value:"aprs"},
    {label:"Investimentos Mensais",value:"investimentosMensais"},
    {label:"Investimentos Anuais",value:"investimentosAnuais"},
    {label:"Instituições Credenciadas",value:"instituicoescredenciadas"},
    {label:"Editais de Credenciamento",value:"editaiscredenciamento"},
    {label:"Relatórios Financeiros",value:"relatoriosfinanceiros"},
    {label:"Composição da Carteira",value:"composicaoCarteira"},
    {label:"Plano de Ação Mensal",value:"planoAcaoMensalFinan"},
    {label:"Políticas de Investimentos",value:"politicasdeinvestimentos"},
    {label:"DIPR",value:"dipr"},
    {label:"ALM",value:"alm"},
    {label:"DAIR",value:"dair"},
    {label:"Relatórios Trimestrais de Investimentos",value:"relatoriostrifinanceiros"},
    {label:"Relatórios Semestrais de Diligência",value:"relatoriosdilifinanceiros"},

    
  ];
  mouvidoria:any = [
    {label:"Selecione a Categoria",value:null},
    {label:"Portarias de Nomeação Ouvidoria",value:"portNomeacaoOuvid"},
    {label:"Relatório Semestral Ouvidoria",value:"relatSemesOuvid"},
    {label:"Regulamentação Fale Conosco",value:"regulamentacaoFale"},

  ];

  mjuridico:any=[
    {label:"Selecione a Categoria",value:null},
    {label:"Legislações Federais",value:"legislacoesfederais"},
    {label:"Legislações Municipais",value:"legislacoesMunicipais"},
    {label:"Jurisprudencias Diviprev",value:"jurisprudencias"},
    {label:"Acordãos TCE",value:"acordaosTCE"},
  ];

  mcolegiados:any=[
    {label:"Selecione a Categoria",value:null},
    {label:"Ata Conselho Administrativo",value:"ataadministrativo"},
    {label:"Ata Conselho Fiscal",value:"atafiscal"},
    {label:"Ata Comitê de Investimentos",value:"atainvestimentos"},
    {label:"Ata Junta de Recursos",value:"atajuntaderecursos"},
    {label:"Portarias do Comitê de Investimentos",value:"portariainvestimentos"},
    {label:"Portarias de Nomeação C. Administrativo",value:"portariaNomeacaoAdm"},
    {label:"Portarias de Nomeação C. Fiscal",value:"portNomecaoFiscal"},
    {label:"Portarias de Nomeação J. Recursos",value:"portNomeacaoJunta"},
    {label:"Portarias de Nomeação C. Investimentos",value:"portNomeacaoComite"},
    {label:"Certificados C. Investimentos",value:"certificadosComite"},
    {label:"Certidões e Declarações C.Adm",value:"certdecadm"},
    {label:"Certidões e Declarações C.Fiscal",value:"certdecfiscal"},
    {label:"Certidões e Declarações Comite Inv.",value:"certdeccomite"},
    {label:"Portaria Nomeação Gestor Comite Inv.",value:"portnomeacaoGestorInv"},
    {label:'Certificados C. Administrativo',value:'certificadosAdm'},
    {label:'Certificados C. Fiscal',value:'certificadosFiscal'},

  ];

  mcinterno:any=[
    {label:"Selecione a Categoria",value:null},
    {label:"Portarias de Nomeação",value:"portNomeacaoCI"},
    {label:"Relatoriso Auditoria Controle Interno",value:"relaudcontrinter"},
    {label:"Relatórios Trimestrais",value:"relTriCI"},
    {label:"Relatórios Semestrais",value:"relSemesCI"},
    {label:"Certificados",value:"certificadosCI"},
  ];
  mbeneficios:any=[
    {label:"Selecione a Categoria",value:null},
    {label:"Requerimentos",value:"requerimentos"},
    {label:"Aposentadorias Concedidas",value:"aposentadoriasconcedidas"},
  ];
  mprogestao:any=[
    {label:"Selecione a Categoria",value:null},
    {label:"Relatório de Governança Corporativa",value:"relGovernancaCorporativa"},
    {label:"Planejemento",value:"planejamento"},
    {label:"Exames Admissionais",value:"examesAdmissionais"},
    {label:"Perícias Médicas",value:"periciasMedicas"},
    {label:"*Diviprev",value:"periciasMedicasDiv"},
    {label:"*Ente",value:"periciasMedicasEnt"},
    {label:"CIPA",value:"cipa"},
    {label:"PPP/LTCAT",value:"pppltcat"},
    {label:"REVISÃO DE BENEFÍCIOS AP. Por Incap.",value:"revapos"},
    {label:"Plano Anual",value:"planoAnual"},
    {label:"Decretos de Nomeação Limites de Alçada",value:"decretoNomeacaoAlcada"},
    {label:"Portarias de Nomeação de Segregação",value:"portNomeacaoSegregacao"},
    {label:"Portarias de Nomeação Diretoria",value:"portNomeacaoDiretoria"},
    {label:"Diplomas da Diretoria",value:"diplomasDiretoria"},
    {label:"Portarias de Nomeação Gestão de Pessoas",value:"portNomeacaoGesPessoas"},
    {label:"Audiências Públicas",value:"prestacoesCamara"},
    {label:"Plano de Ação e Capacitação",value:"planoAcaoCapacitacao"},

    {label:"*Conselheiro 2019",value:"planoAcaoCapacitacaoConse2019"},
    {label:"*Conselheiro 2020",value:"planoAcaoCapacitacaoConse2020"},
    {label:"*Conselheiro 2021",value:"planoAcaoCapacitacaoConse2021"},
    {label:"*Conselheiro 2022",value:"planoAcaoCapacitacaoConse2022"},
    {label:"*Conselheiro 2023",value:"planoAcaoCapacitacaoConse2023"},
    {label:"*Conselheiro 2024",value:"planoAcaoCapacitacaoConse2024"},
    {label:"*Conselheiro 2025",value:"planoAcaoCapacitacaoConse2025"},
    {label:"*Conselheiro 2025",value:"planoAcaoCapacitacaoConse2026"},

    {label:"*Servidor 2019",value:"planoAcaoCapacitacaoServ2019"},
    {label:"*Servidor 2020",value:"planoAcaoCapacitacaoServ2020"},
    {label:"*Servidor 2021",value:"planoAcaoCapacitacaoServ2021"},
    {label:"*Servidor 2022",value:"planoAcaoCapacitacaoServ2022"},
    {label:"*Servidor 2023",value:"planoAcaoCapacitacaoServ2023"},
    {label:"*Servidor 2024",value:"planoAcaoCapacitacaoServ2024"},
    {label:"*Servidor 2025",value:"planoAcaoCapacitacaoServ2025"},
    {label:"*Servidor 2026",value:"planoAcaoCapacitacaoServ2026"},

    {label:"Cursos de Capacitação 2026",value:"cursosCap2026"},

    {label:"Plano de ações Aposentadoria",value:"acoesAposentadoria"},
    {label:"Plano de ações Pos Aposentadoria",value:"acoesPosAposentadoria"},
    {label:"Seminários Segurados",value:"seminariosSegurados"},
    {label:"Termo de Ciência e Compromisso (PSI)",value:"termoccompromisso"},
    {label:"*Prestador de Serviço",value:"termoccompromissopres"},
    {label:"*Servidor",value:"termoccompromissoser"},
    {label:"Termo de Ciência e Compromisso (G.Corp)",value:"termoccompromisso2"},
    {label:"*Prestador de Serviço",value:"termoccompromisso2pre"},
    {label:"*Servidor",value:"termoccompromisso2ser"},
    {label:"Concurso Público",value:"concursoPublico"},
    {label:"Certidão à Dívida Ativa da União",value:"certidaoUniao"},
    {label:"Certidão de Regularidade do FGTS.",value:"certidaoRegularidade"},
    {label:"MAPA - Benefícios",value:"mapBeneficios"},
    {label:"*Manuais e Mapeamentos",value:"mapBeneficiosman"},
    {label:"*Relatórios de Indicadores",value:"mapBeneficiosrel"},
    {label:"*Declaração de Ciência",value:"mapBeneficiosdec"},
    {label:"MAPA - COMPREV",value:"mapComprev"},
    {label:"*Manuais e Mapeamentos",value:"mapComprevman"},
    {label:"*Relatórios de Indicadores",value:"mapComprevRel"},
    {label:"*Declaração de Ciência",value:"mapComprevDec"},
    {label:"MAPA - Investimentos.",value:"mapInvestimentos"},
    {label:"*Manuais e Mapeamentos",value:"mapInvestimentosman"},
    {label:"*Relatórios de Indicadores",value:"mapInvestimentosrel"},
    {label:"*Declaração de Ciência",value:"mapInvestimentosdec"},
    {label:"MAPA - T.I.",value:"mapTI"},
    {label:"*Manuais e Mapeamentos",value:"mapTIman"},
    {label:"*Relatórios de Indicadores",value:"mapTIrel"},
    {label:"*Declaração de Ciência",value:"mapTIdec"},
    {label:"MAPA - Arrecadações",value:"arrecadacao"},
    {label:"*Manuais e Mapeamentos",value:"arrecadacaoman"},
    {label:"*Relatórios de Indicadores",value:"arrecadacaorel"},
    {label:"*Declaração de Ciência",value:"arrecadacaodec"},
    {label:"C. DEV. Divida Ativ. Municipal",value:"cdebmunic"},
    {label:"C. DEB. TRIB. FAZENDA MG",value:"cdebfazenda"},
    {label:"Diversos",value:"diversosArq"},
    {label:"certidoes diretoria executiva",value:"certidoesdiretoriaexecutiva"},
    {label:"Cert. Diretoria",value:"certificadosDiretoria"},
    {label:"Premios",value:"premiosInstituto"},
    {label:"Responsabilidade Corporativa e Social", value:"responsabilidadeCorporativa"},
    {label:"Relatório do Regime de Previdência Complementar", value:"relatorioRegimeComplementar"},
  ];

  municos:any = [
    {label:"Selecione a Categoria",value:null},
    {label:"Diversos",value:"unico"}
  ]

  mbasedados:any = [
    {label:"Selecione a Categoria",value:null},
    {label:"Diversos",value:"unico"},
    {label:"Censo 2016",value:"censo2016"},
    {label:"Censo 2017",value:"censo2017"},
    {label:"Censo 2020",value:"censo2020"},
    {label:"Censo 2021",value:"censo2021"},
    {label:"Censo 2022",value:"censo2022"},
    {label:"Censo 2023",value:"censo2023"},
    {label:"Censo 2024",value:"censo2024"},
    {label:"Censo 2025",value:"censo2025"},
    {label:"Censo 2026",value:"censo2026"},
    {label:"ESOCIAL",value:"esocial"},
    {label:"*Ente",value:"esocialEnte"},
    {label:"*Ente_2023",value:"esocialEnte2023"},
    {label:"*Ente_2024",value:"esocialEnte2024"},
    {label:"*Ente_2025",value:"esocialEnte2025"},
    {label:"*Ente_2026",value:"esocialEnte2026"},
    {label:"*RPPS",value:"esocialRpps"},
    {label:"*RPPS_2023",value:"esocialRpps2023"},
    {label:"*RPPS_2024",value:"esocialRpps2024"},
    {label:"*RPPS_2025",value:"esocialRpps2025"},
    {label:"*RPPS_2026",value:"esocialRpps2026"},

  ];

  precat:any[]=[
    {label:"Selecione o Tipo",value:null},
    {label:"UNICOS",value:this.municos},
    {label:"Atuarial",value:this.matuarial},
    {label:"Beneficios",value:this.mbeneficios},
    {label:"Contabil",value:this.mcontabil},
    {label:"Financeiro",value:this.mfinanceiro},
    {label:"Jurídico",value:this.mjuridico},
    {label:"Colegiados",value:this.mcolegiados},
    {label:"Ouvidoria",value:this.mouvidoria},
    {label:"Pro-Gestão",value:this.mprogestao},
    {label:"C. Interno",value:this.mcinterno},
    {label:"C. Base de Dados",value:this.mbasedados},
  ];
  categorias:any[]=[{label:"Selecione a Categoria",value:null},
  // {label:"Informe Contábil",value:"informecontabil"},
  // {label:"Demonstrações Contábeis",value:"notasexplicativas"},
  // {label:"Ata Conselho Administrativo",value:"ataadministrativo"},
  // {label:"Ata Conselho Fiscal",value:"atafiscal"},
  // {label:"Ata Comitê de Investimentos",value:"atainvestimentos"},
  // {label:"Ata Junta de Recursos",value:"atajuntaderecursos"},
  {label:"Atas do Patrimônio",value:"atapatrimonio"},
  // {label:"Licitações",value:"licitacoes"},
  // {label:"Prestações de Conta (Câmara)",value:"prestacoesCamara"},
  // {label:"Políticas de Investimentos",value:"politicasdeinvestimentos"},
  // {label:"DIPR",value:"dipr"},
  // {label:"Relatórios Financeiros",value:"relatoriosfinanceiros"},
  // {label:"Legislações Federais",value:"legislacoesfederais"},
  // {label:"Legislações Municipais",value:"legislacoesMunicipais"},
  // {label:"Jurisprudencias Diviprev",value:"jurisprudencias"},
  // {label:"Resultados Atuariais",value:"resultadosAtuariais"},
  // {label:"Portarias do Comitê de Investimentos",value:"portariainvestimentos"},
  // {label:"Editais de Credenciamento",value:"editaiscredenciamento"},
  // {label:"Instituições Credenciadas",value:"instituicoescredenciadas"},
  // {label:"Requerimentos",value:"requerimentos"},
  // {label:"Aposentadorias Concedidas",value:"aposentadoriasconcedidas"},
  // {label:"Investimentos Mensais",value:"investimentosMensais"},
  // {label:"APR'S",value:"aprs"}

  ];

  mudouSetor(){
    console.log("Mudou setor");
    this.categorias = this.formulario.controls.setor.value;
  }

  voltar(){
    this.volt.emit(true);
  }

  obterExtensao(nome:any){
    var fileExt = nome.split('.').pop();
    return fileExt;
  }

  editar(arquivo){
    console.log("EDITAR ->",arquivo);
    this.formulario.get("id").setValue(arquivo.id);
    this.formulario.get("categoria").setValue(arquivo.categoria);
    this.formulario.get("titulo").setValue(arquivo.titulo);
    this.formulario.get("descricao").setValue(arquivo.descricao);
    this.formulario.get("dia").setValue(arquivo.dia);
    this.nome_completo = arquivo.link;
  }

  excluirArquivo(idArquivo){
    console.log("Remover Arquivo - >",idArquivo);
    let dados ={
      tabela:'arquivo',
      id: idArquivo
    }
    this.dao.submeter(dados,"excluirGenerico").then(res=>{
      this.acao = res;
      this.limparFormulario();
    });
  }

  limparFormulario(){
    this.formulario.get("id").setValue(-1);
    
    this.formulario.get("titulo").setValue(null);
    this.formulario.get("descricao").setValue(null);
    this.formulario.get("dia").setValue(null);
    this.nome_completo = null;
  }

  pegarComponente(){
    let el = document.getElementById('up');
    console.log('elemento',el);
  }

  salvar(){
    console.log("Formulario->",this.formulario);
    //this.enviarToast('red','Inválido','Preencha todos os campos para poder enviar o arquivo!');
    if(this.formulario.valid && (!!this.nome_completo) ){
        let dados = JSON.parse(JSON.stringify(this.formulario.value))
        dados.link = this.nome_completo;

        dados.tipo = this.obterExtensao(this.nome_completo); 
        dados.tipo = dados.tipo.toLowerCase();

        if(this.licitacao){
          dados.idLicitacao = this.licitacao.id;
        }

        console.log("Dados submetidos ->",dados);
        this.dao.submeter(dados,"cadastrarArquivo").then(result=>{
            this.acao = result;// estimulo o componente filho
            this.limparFormulario();
            this.enviarToast('success','Sucesso','Sucesso!');
            this.pegarComponente();
        });
    }else{
      this.enviarToast('error','Inválido','Preencha todos os campos para poder enviar o arquivo!');
      console.log("Erro ao tentar salvar");
    }

  }

  descricao:any;

  ngOnInit() {
    this.carregarFormularios();
    if(this.licitacaoKey){
      this.formulario.controls.categoria.setValue("licitacaoNova"+this.licitacao.id);
    }
  }

  enviarToast(cor, titulo, texto) {
    this.messageService.add({ severity: cor, summary: titulo, detail: texto });
  }

  verificaValidTouched(campo) {    
    return !this.formulario.get(campo).valid && this.formulario.get(campo).touched;
  }

  carregarFormularios() {

    this.formulario = this.formBuilder.group({
      id: [-1],
      titulo:[null, Validators.required],
      descricao:[null,Validators.required],
      categoria:[null,Validators.required],
      dia:[null,Validators.required],
      setor:[null]
      
      
    })
  }


  onUploadFinished(file: FileHolder) {  
    console.log(file.serverResponse.response._body);
    let temp = JSON.stringify(file.serverResponse.response._body).split('"');
    this.nome_arquivo = temp[2].replace(/[\\"]/g, '');  
   this.nome_completo = "http://www.diviprev.mg.gov.br/arquivos-lista/" + this.nome_arquivo; 
   console.log("Nome completo do arquivo->",this.nome_completo);  
  }

  onRemoved(file: FileHolder) {
    // do some stuff with the removed file.
  }
  
  onUploadStateChanged(event) {
    if(JSON.stringify(event) == 'true'){
      this.loading = true;
    }else{
      this.loading = false;
    }  
  }

}
